import { Grid, Link } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { MarkdownContent } from '@backstage/core-components';
import { GridItem } from '../GridItem';
import { LifecycleChip, TypeChip } from '../EntityChips';
import { AddonCostField } from './AddonCostField';

// Helper function to render field content consistently
const renderFieldContent = (
  value: string | undefined,
  useMarkdown: boolean = true,
  owner: string | undefined,
  fallback: string = 'Not specified',
) => {
  // Handle empty strings and undefined values
  const cleanValue = value?.trim();
  const content = cleanValue || fallback;

  if (!useMarkdown) {
    return content;
  }

  if (owner) {
    // const ownerRef = parseEntityRef(owner);
    const ownerUrl = 'google.com';
    // const ownerUrl = `/catalog/${
    //   ownerRef.namespace || 'default'
    // }/${ownerRef.kind.toLowerCase()}/${encodeURIComponent(ownerRef.name)}`;
    return (
      <Link href={ownerUrl} color="inherit" underline="hover">
        {content}
      </Link>
    );
  }

  return <MarkdownContent content={content} dialect="common-mark" />;
};

export interface EntityBasicInfoProps {
  entity: Entity;
}

export const EntityBasicInfo: React.FC<EntityBasicInfoProps> = ({ entity }) => (
  <Grid container>
    <GridItem
      label="Owner"
      value={renderFieldContent(
        typeof entity.spec?.owner === 'string' ? entity.spec.owner : undefined,
        true,
        typeof entity.spec?.owner === 'string' ? entity.spec.owner : undefined,
      )}
      gridSizes={{ xs: 12, sm: 4 }}
    />
    <GridItem
      label="Type"
      value={
        <TypeChip
          type={
            typeof entity.spec?.type === 'string' ? entity.spec.type : undefined
          }
        />
      }
      gridSizes={{ xs: 12, sm: 4 }}
    />
    {entity.spec?.lifecycle && (
      <GridItem
        label="Lifecycle"
        value={
          <LifecycleChip
            lifecycle={
              typeof entity.spec?.lifecycle === 'string'
                ? entity.spec.lifecycle
                : undefined
            }
          />
        }
        gridSizes={{ xs: 12, sm: 4 }}
      />
    )}
    <AddonCostField entity={entity} />
  </Grid>
);
